
import React from 'react';
import { useState, useEffect } from 'react';
import { makeAPI, makeApiCall_v1 } from "../../services/api";
import { getViteImage } from '../../utils/utils';
// import { useGlobalState, useGlobalDispatch } from "../../contexts/user";

import Croppie from "croppie";
import "croppie/croppie.css";


export default function ImageUploadPopup({ onClose, onAvatarSelect }) {
    let cropper = null;
    const [customAvatar, setCustomAvatar] = useState(null);
    const [token, setUser] = useState(localStorage.getItem("token"));
    const  user  = JSON.parse(localStorage.getItem("user")) || null;
    // const dispatch = useGlobalDispatch();
    let blobData = null;

    const updateStoredUser = (partialUser) => {
        try {
            const current = JSON.parse(localStorage.getItem("user") || "{}");
            const updated = { ...current, ...partialUser };
            localStorage.setItem("user", JSON.stringify(updated));
            window.dispatchEvent(new CustomEvent("auth:updated"));
            return updated;
        } catch (error) {
            console.error("Failed to sync user in localStorage:", error);
            return null;
        }
    };

    const handleSelectAvatar = async (avatar) => {

        console.log("Avatart", avatar);

        if (token) {

            try {
                let data = { profile_pic: avatar };
                const userData = await makeAPI('/api/update_profile', 'post', true, data);

                if (userData.status === "S") {
                    updateStoredUser({ profile_pic: avatar, img_url: "" });
                    // onAvatarSelect("../assets/img/profile_avatar/" + avatar + ".avif");
                    onAvatarSelect(Number(avatar));
                    const updatedUser = { ...user, profile_pic: avatar, img_url: "" }; // Example change
                    // dispatch({ type: "SET_USER", payload: updatedUser });

                    onClose();
                }

            } catch (error) {
                console.error("Error updating user data:", error);
            }

        }
        else {
            onAvatarSelect(Number(avatar));
            onClose();
        }

    };

    function CropedImage(params) {
        // alert("Clicked");
        blobData = null;
        if (!cropper) return;
        document.getElementById('preview').style.display = "inline-block";
        cropper.result({
            type: 'blob',
            // size: 'viewport',
            size: { width: 200, height: 200 },
            format: 'png',
            circle: false,
            quality: 1
        }).then(function (croppedBlob) {
            blobData = croppedBlob;
            // console.log(" Cropped Image Base64: ", cropper);
            console.log("Cropped Blob", blobData);

            document.getElementById('preview').src = URL.createObjectURL(croppedBlob);
            document.getElementById('preview').style.borderRadius = "50%";
            document.getElementsByClassName('cr-boundary')[0].style.display = "none";
            document.getElementsByClassName('cr-slider-wrap')[0].style.display = "none";
            document.getElementById('edit-button').style.display = "inline-block";
            document.getElementById('cropBtn').style.display = "none";
            document.getElementById('fileInput').style.display = "none";
            document.getElementById('edit-button').addEventListener('click', function () {
                document.getElementById('fileInput').style.display = "inline-block";
                document.getElementsByClassName('cr-boundary')[0].style.display = "block";
                document.getElementsByClassName('cr-slider-wrap')[0].style.display = "block";
                document.getElementById('edit-button').style.display = "none";
                document.getElementById('cropBtn').style.display = "inline-block";
                document.getElementById('preview').style.display = "none";
                document.getElementById('save-button').style.display = "none";
            });
            document.getElementById('save-button').style.display = "inline-block";
        });
    }

    function Fileuploaded(e) {
        let file = e.target.files[0];
        if (!file) return;
        const allowedTypes = ["image/webp", "image/png", "image/jpeg"];
        const maxSize = 2 * 1024 * 1024; // 2mb
        if (!allowedTypes.includes(file.type)) { // validate Type.
            alert("Image type not supported !");
            e.target.value = "";
            return;
        }
        if (file.size > maxSize) { // Validate size
            alert("File size exceeds 2MB !");
            e.target.value = "";
            return;
        }
        const reader = new FileReader();
        reader.onload = function (e) {
            let image = document.getElementById('preview');
            image.src = e.target.result;
            image.style.display = "none";

            // Destroy existing cropper if exists
            if (cropper) {
                cropper.destroy();
            }

            // Initialize Croppie
            cropper = new Croppie(image, {
                boundary: { width: "100%", height: 300 },
                viewport: { width: 200, height: 200, type: 'circle' },
                enableExif: true,
                showZoomer: true,
                mouseWheelZoom: 'ctrl',
                enforceBoundary: true,
            });

            cropper.bind({
                url: e.target.result,
                orientation: 1,

            }).then(function () {
                cropper.setZoom(0);
            });
            cropper.result('blob')
            document.getElementsByClassName('cr-boundary')[0].style.marginTop = "12px";
            document.getElementById('cropBtn').style.display = "inline-block";

        }
        reader.readAsDataURL(file);
    }

    async function saveData() {
        // e.prevant.default.value();
        // document.getElementById('preloader').style.visibility = "visible";
        // document.getElementById('preloader').style.opacity = 1;
        document.getElementById('save-button').disabled = "true";
        document.getElementById('edit-button').disabled = "true";
        document.getElementById('save-button').textContent = "Uploading..."
        const formData = new FormData();
        formData.append("image", blobData, "avatar.png");
        formData.append("user_id", user?.user_id );
        try {
            const userData = await makeApiCall_v1('/api/image_upload', 'post', false, formData);
            if (userData.status === 'S') {
                // document.getElementById('preloader').style.display ="none";
                // alert("saved Successfully");
                // Updating in local storage
                //    console.log("U",userData);
                var Image_url = userData?.data?.img_url;
                updateStoredUser({ img_url: Image_url });

                // onAvatarSelect("../assets/img/profile_avatar/" + avatar + ".avif");
                onAvatarSelect(Image_url);
                const updatedUser = { ...user, img_url: Image_url }; // Example change
                // dispatch({ type: "SET_USER", payload: updatedUser });

                onClose();
            }
            else {
                console.log("show loader");
                setTimeout(() => {
                    // document.getElementById('preloader').style.visibility = "hidden";
                    // document.getElementById('preloader').style.opacity = 0;
                }, 3000);
            }
        } catch (e) {
            console.error(e);
        }
    }


    function PresetUploadBtn(params) {
        // alert("Preset Upload Clicked");
        document.getElementById('upload-preset-images').innerHTML = "";
        document.getElementById('image-upload-btn').classList.remove('active');
        document.getElementById('image-upload-btn').setAttribute('aria-pressed', 'false');
        document.getElementById('image-upload').style.display = "none";
        document.getElementById('preset-upload').style.display = "block";
        document.getElementById('preset-upload-btn').classList.add('active');
        document.getElementById('preset-upload-btn').setAttribute('aria-pressed', 'true');
        for (let index = 0; index <= 116; index++) {
            // Runtime creation of img elements
            const img_container = document.createElement('div');
            img_container.style.display = "inline-block";
            img_container.style.margin = "10px";
            img_container.style.textAlign = "center";
            img_container.style.cursor = "pointer";
            const img_element = document.createElement('img');
            img_element.src = getViteImage(`profile_avatar/${index}.avif`);
            img_element.alt = `Preset ${index}`;
            img_element.style.width = "80px";
            img_element.style.height = "auto";
            img_element.style.objectFit = "cover";
            img_element.style.borderRadius = "8px";
            img_element.style.border = "1px solid black";
            img_element.style.color = "#fff"
            img_element.onclick = function () {
                handleSelectAvatar(index);
            };
            img_container.appendChild(img_element);
            const caption = document.createElement('p');
            caption.textContent = `Preset ${index + 1}`;
            caption.style.color = "#fff"
            img_container.appendChild(caption);
            document.getElementById('upload-preset-images').appendChild(img_container);
        }
        //onclick="saveData(${index})" 

    }

    function ImageUploadBtn(params) {
        // alert("Image Upload Clicked");
        document.getElementById('preset-upload-btn').classList.remove('active');
        document.getElementById('preset-upload-btn').setAttribute('aria-pressed', 'false');
        document.getElementById('image-upload-btn').classList.add('active');
        document.getElementById('image-upload-btn').setAttribute('aria-pressed', 'true');
        document.getElementById('image-upload').style.display = "block";
        document.getElementById('preset-upload').style.display = "none";
        document.getElementById('upload-title').innerText = "UPLOAD YOUR IMAGE HERE";
        document.getElementById('image-upload').getElementsByTagName('p')[0].innerText = "Supported format: jpg, png, webp";
        document.getElementById('fileInput').style.display = "inline-block";
        document.getElementById('fileInput').textContent = "none";
        document.getElementById('fileInput').value = "";
        document.getElementById('preview').src = getViteImage("profile_avatar/0.avif");
        document.getElementById('preview').style.borderRadius = "50%";
        document.getElementById('preview').style.width = "200px";
        document.getElementById('preview').style.height = "200px";
        document.getElementById('preview').style.objectFit = "cover";
        // document.getElementById('preview').style.border = "2px solid #ff810e";
        document.getElementById('preview').style.display = "inline-block";
        document.getElementById('edit-button').style.display = "none";
        document.getElementById('cropBtn').style.display = "none";
        document.getElementById('save-button').style.display = "none";
        var crboundary = document.getElementsByClassName('cr-boundary');
        if (crboundary.length !== 0) {
            crboundary[0].style.display = "none";
        }
        var crslider = document.getElementsByClassName('cr-slider-wrap');
        if (crslider.length !== 0) {
            crslider[0].style.display = "none";
        }

    }


    function closeModal() {
        document.getElementsByClassName('modal')[0].style.display = "none";
    }


    function OpenMOdal() {
        document.getElementsByClassName('modal')[0].style.display = "block";
    }

    function handleOverlayClick(e) {
        if (e.target === e.currentTarget) {
            onClose();
        }
    }

    useEffect(() => {
        window.addEventListener('DOMContentLoaded', window.domcontentloaded);
        OpenMOdal();
    }, []);

    return (
        <>

            <div className="modal" tabIndex="-1" role="dialog" style={{ background: "rgba(0,0,0,0.63)" }} onClick={handleOverlayClick}>
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document" onClick={(e) => e.stopPropagation()}>
                    <div className="modal-content" style={{ backgroundColor: "rgba(49,49,49,49)" }}>

                        <div className="modal-header" style={{ display: "block", borderBottom: "none" }}>
                            <div className="contianer">
                                <div className="row">
                                    <div className="col-5">
                                        {/* <button type="button" className="toggle-btn-popup active fs-md-5" id="image-upload-btn" data-bs-toggle="button" autoComplete="off" aria-pressed="true" onClick={ImageUploadBtn} style={{border:"1px solid #ff810e"}}>Image
                                            Upload</button> */}
                                        <button className="uk-button uk-button-secondary toggle-btn-popup active text-white" id="image-upload-btn" type="button" onClick={ImageUploadBtn}>Image Upload</button>
                                    </div>
                                    <div className="col-5">
                                        {/* <button type="button" className="toggle-btn-popup fs-md-5" id="preset-upload-btn" data-bs-toggle="button" autoComplete="off" onClick={PresetUploadBtn} style={{border:"1px solid #ff810e"}}>Preset
                                            Upload</button> */}
                                        <button className="uk-button uk-button-secondary toggle-btn-popup text-white" id="preset-upload-btn" type="button" onClick={PresetUploadBtn}>Preset Image</button>

                                    </div>
                                    <div className="col-2">
                                        <button type="button" className="close close-button" data-dismiss="modal"
                                            aria-label="Close" onClick={onClose} style={{ position: "relative", top: "6px", display: "flex", justifyContent: "center", alignItems: "center", left: "10%", width: "80%", height: "80%", border: "1px solid #ac2925", backgroundColor: "#c9302c", borderRadius: "3px" }}>
                                            <span aria-hidden="true" style={{ fontSize: "26px", color: "#FFF" }}>&times;</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-body">
                            <div id="image-upload"
                                style={{ border: "2px dashed #ff810e", padding: "20px", textAlign: "center", cursor: "pointer", width: "100%", height: "520px" }}>
                                {/* <p><span style={{ color: "red" }}>Note *</span> 
                                    Hold <kbd>Ctrl</kbd> and scroll your mouse to zoom the image.<br />
                                    On mobile devices, pinch with two fingers to zoom in and out.</p> */}

                                <h4 id='upload-title'>UPLOAD YOUR IMAGE HERE</h4>
                                <p className='text-white' style={{fontSize:"12px",margin:"0px",marginBottom:"12px"}}>Supported format: <span style={{ color: "#ff810e"}}>jpg, png, webp</span></p>
                                <p className='text-white' style={{fontSize:"12px",margin:"0px",marginBottom:"8px"}}> <span style={{ color: "#ff810e" }}>Note*</span> Files must be under 2MB.</p>
                                <div className="mb-3 mt-1" style={{ textAlign: "center", display: "block" }}>
                                    <input type="file" className="form-control " id="fileInput" accept="image/png, image/jpeg, image/webp"
                                        style={{ display: "inline-block", width: "80%" }} onChange={(e) => Fileuploaded(e)} />
                                    <img id="preview" src={getViteImage('profile_avatar/0.avif')} style={{ display: "inline-block", marginTop: "12px", borderRadius: "50%", width: "200px", height: "200px", objectFit: "cover" }} alt="Preview"
                                        width="100%" />
                                </div>
                            </div>

                            <div id="preset-upload" style={{ display: "none", width: "97%", height: "520px" }} >
                                <h4 className='text-center'>PRESET IMAGE UPLOAD</h4>


                                <div id="upload-preset-images" style={{ width: "100%", left: "5%", position: 'relative' }}></div>

                            </div>
                        </div>
                        <div className="modal-footer" style={{ borderTop: "none" }}>
                            <button type="button" className="btn btn-primary" id="cropBtn" style={{ display: "none", backgroundColor: "#ff810e" }} onClick={CropedImage}>Crop</button>
                            <button id="edit-button" className="btn btn-warning" style={{ marginTop: "10px", display: "none", backgroundColor: "#ff810e", color: "#FFF" }}>Edit
                                Image</button>
                            <button id="save-button" className="btn btn-success" style={{ marginTop: "10px", display: "none", backgroundColor: "#ff810e" }} onClick={saveData}
                            >Save</button>
                        </div>
                    </div>
                </div>
            </div>
            <style>
                {
                    `
                                /* Image upload popup styles */
                                body.dark-theme .uk-button-secondary{
                                background:#161616;
                                color:#fff
                                }
            .toggle-btn-popup {
                width: 100%;
                padding: 10px 15px;
                background: #ff810e;
                color: #fff;
                border: none;
                border-radius: 6px;
                font-weight: 600;
                transition: background 0.3s;
            }

            .toggle-btn-popup.active {
                background: #ff810e !important;
                border: 1px solid #ff810e;
            }

            .toggle-btn-popup:not(.active) {
                /* background: #303234; */
            }

                `
                }
            </style>
        </>
    );
}
